module.exports = __webpack_public_path__ + "media/images/flags/4x3/tls-f7f0998622f591edea2f390225e3a1b0.svg";